"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * True if the node is a list container
 */
var isList = function (opts) { return function (node) {
    return opts.types.includes(node.type);
}; };
exports.default = isList;
//# sourceMappingURL=isList.js.map